import { createTheme } from "@mui/material/styles";
import { cssVar } from "./theme";

// MUI adapter. MUI needs real color strings to derive its hover / disabled /
// contrast shades, so the dark palette is read from the same CSS tokens the
// rest of the app uses (src/Styles/tokens) instead of being repeated here.
// Light is left as MUI's stock palette, which is what the app has always
// rendered with. Call this after <html data-theme> has been updated.
export const buildMuiTheme = (resolvedMode) => {
  if (resolvedMode !== "dark") {
    return createTheme({ palette: { mode: "light" } });
  }

  return createTheme({
    palette: {
      mode: "dark",
      background: {
        default: cssVar("--hc-canvas", "#04181a"),
        paper: cssVar("--hc-surface", "#0a2326"),
      },
      text: {
        primary: cssVar("--hc-text", "#e6eef0"),
        secondary: cssVar("--hc-text-muted", "#9db8bc"),
      },
      divider: cssVar("--hc-border", "#1f4c52"),
    },
    components: {
      // MUI lightens elevated Paper in dark mode with a gradient overlay;
      // our surfaces get their elevation from the tokens instead.
      MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    },
  });
};
